var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonHomework = function SvgButtonHomework(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    preserveAspectRatio: "none",
    viewBox: "0 0 40 40"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ffce41}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7 2.6c-.3-.1-.7-.2-1-.2C15.5.2 3.4 5.7 1 15.2c-2.5 9.6 3.7 20.7 13.9 22.9C25 40.3 36.5 33.5 39 23.9c2.5-9.3-3-18.8-12.3-21.3m-1 33.4c-9.2 3.5-19.2-.6-22.4-9.2S5 8.3 14.2 4.8s19.2.6 22.4 9.2c3.1 8.7-1.7 18.5-10.9 22",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 5C10.1 6.3 3.2 15.1 4 23.2c.8 8.2 9.5 13.1 18 11.8s14.9-8.2 14.1-16.3c-.8-8.2-8.9-15-17.4-13.7M14 25.8l-.1-1.8 1.1-.2V21h-4.2v2.9l1.1.2-.1 1.8H7.5l.1-1.8 1.1-.2v-7.6l-1.1-.2-.1-1.5h4.3l.1 1.5-1.1.2v3.1H15v-3l-1.1-.2v-1.3h4.3v1.3l-1.1.2V24l1.1.2.1 1.8H14zm17.7-9.4-1.8 9.7H28l-2.2-7.5-2.2 7.8h-2l-1.9-10-.9-.1.1-1.5h3.8l-.1 1.5-1 .2 1.2 5.8 1.8-6.8h1.5l2.1 6.8 1.2-5.8-1-.2v-1.5h3.8l.2 1.5z",
    className: "st0"
  })));
};
export default SvgButtonHomework;